"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mergeUint8Arrays = exports.sortDeck = void 0;
function sortDeck(deck) {
    deck.sort((a, b) => (a.cardCode < b.cardCode ? -1 : 1));
}
exports.sortDeck = sortDeck;
function mergeUint8Arrays(a, b) {
    const merged = new Uint8Array(a.length + b.length);
    merged.set(a);
    merged.set(b, a.length);
    return merged;
}
exports.mergeUint8Arrays = mergeUint8Arrays;
